import { H1 } from "@holigral/shared/ui/components"
import Account from "./Account"
import { useT } from "@/i18n"

export default function AccountPage() {
  const { t } = useT("auth")

  return (
    <div className="flex flex-col items-center justify-center py-8">
      <H1 className="mb-4">{t("myAccount")}</H1>
      <div className="sm:w-2/3 md:w-1/2">
        <Account />
      </div>
    </div>
  )
}
